/**
 * @description - remove unwanted HTML tags and spaces
 * @param creditorAuthInfo - creditorAuthInfo
 * @returns - return creditorAuthInfo after formatting
 */
export const formatCreditorAuthInfo = (
  creditorAuthInfo: string | null | undefined
): string => {
  try {
    if (!creditorAuthInfo) {
      return "";
    }

    return creditorAuthInfo
      .replace(/<[^>]*>?/gm, " ")
      .replace(/\s+/g, " ")
      .trim();
  } catch (error) {
    return "";
  }
};
